import * as React from 'react';

import { Typography } from '../Typography';
import { Job } from './components/Job';

import { declensionOfNumbers } from '../../utils/declensionOfNumbers';

import * as styles from './styles.css';
import { IVacancyV2Schema } from '../../common/repositories/job-vacancies-backend/entities/vacancies_listing/VacancyV2Schema';
import { useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';
import { NBSP } from '../../constants/symbols';

export interface IGroupJobsProps {
  title: string;
  count: number;
  vacancies: IVacancyV2Schema[];
}

const { Title } = Typography;

export const GroupJobs: React.FC<IGroupJobsProps> = ({ title, count, vacancies }) => {
  const amount = `${count}${NBSP}${declensionOfNumbers(vacancies.length, ['вакансия', 'вакансии', 'вакансий'])}`;
  const deviceType = useDeviceType();

  return (
    <div className={styles.root}>
      <header className={cn(styles.header, styles[deviceType])}>
        <Title level={deviceType === 'desktop' ? 3 : 6}>{title}</Title>
        <span className={styles.amount}>{amount}</span>
      </header>
      <ul className={cn(styles.jobs, styles[deviceType])}>
        {vacancies.map((item, index) => (
          <li key={index} className={cn(styles.job, styles[deviceType])}>
            <a href={`/vacancies/${item.id}/`} target="_self">
              <Job key={index} {...item} />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

GroupJobs.displayName = 'GroupJobs';
